<template>
 <div>
   <label class="form-label" v-if="showlabel">
     <span>{{ label }}</span>
     <span v-if="required"> *</span>
   </label>
    <div class="row">
      <div class="col">
        <DateGroup v-model="date"
                   :showlabel="true"
                   :label="$t('date')"
                   :required="required"/>
      </div>
      <div class="col col-auto">
        <TimeGroup v-model="time"
                   :showlabel="true"
                   :label="$t('time')"
                   :required="required"/>
      </div>
    </div>
   <ValidationError class="mt-1"
                    v-if="showErrors"
                    :validationId="validationId"/>
 </div>
</template>

<script setup>
import TimeGroup from "@/components/form/TimeGroup"
import DateGroup from "@/components/form/DateGroup"
import ValidationError from "@/components/form/ValidationError.vue"
import {computed, ref, watch} from "vue"

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  label: {},
  modelValue: {},
  showErrors: {
    type: Boolean,
    default: false
  },
  showlabel: {
    type: Boolean,
    default: true
  },
  calendarIcon: {
    type: Boolean,
    default: true
  },
  readonly: {
    type: Boolean,
    default: false
  },
  validationId: {},
  required: {
    type: Boolean,
    default: false
  },
})

const date = ref(props.modelValue ? props.modelValue.substr(0, 10) : null)
const time = ref(props.modelValue ? props.modelValue.substr(11, 5) : null)

const datetime = computed(() => {
  return (date.value ? date.value : '0000-00-00')+' '+(time.value ? time.value : '00')+':00'
})

watch(date, () => {
  emit('update:modelValue', datetime.value)
})

watch(time, () => {
  emit('update:modelValue', datetime.value)
})
</script>
